export default "__VITE_ASSET__BGJiFSiW__"